import { render, staticRenderFns } from "./copyBtn.vue?vue&type=template&id=5d7ae648&scoped=true"
import script from "./copyBtn.vue?vue&type=script&lang=js"
export * from "./copyBtn.vue?vue&type=script&lang=js"
import style0 from "./copyBtn.vue?vue&type=style&index=0&id=5d7ae648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7ae648",
  null
  
)

export default component.exports